import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toastCtrl: ToastController) {}
  /*
  setTimeout(async () => {
        if(response.data.message){
          this.toastService.presentToast("confirm", response.data.message, 5000, "top", true);
        }
      }, 1000);
  */

  async presentToast(type:string, msg:string, time:number, position, enableLargeVersion:boolean = false) {
    let toastIcon = '';
    let cssCustomClass = enableLargeVersion  ? 'app-toast large-version ' : 'app-toast ';

    switch (type) {
      case 'confirm':
        cssCustomClass += 'app-confirm-toast';
        toastIcon = 'checkmark-circle';
        break;
      case 'warning':
        cssCustomClass += 'app-warning-toast';
        toastIcon = 'warning';
        break;
      case 'error':
        cssCustomClass += 'app-error-toast';
        toastIcon = 'alert-circle';
        break;
      case 'informative':
        cssCustomClass += 'app-informative-toast';
        toastIcon = 'information-circle';
        break;
    }

    const toast = await this.toastCtrl.create({
      icon: toastIcon,
      message: `${msg}`,
      duration: time,
      position: position, // 'top' | 'bottom' | 'middle';
      cssClass: cssCustomClass,
      buttons: [
        {
          side: 'end',
          icon: 'close',
          role: 'cancel'
        },
      ],
    });

    await toast.present();
  }
}
